var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.hasPicture)?_c('div',{staticClass:"bg-black text-white rounded-full h-full w-full flex items-center justify-center"},[_c('span',[_vm._v(_vm._s(_vm.getInitials))])]):_c('img',{staticClass:"bg-black rounded-full h-full w-full",attrs:{"src":_vm.picture},on:{"error":_vm.onError}})])
}
var staticRenderFns = []

export { render, staticRenderFns }